// core
import React from "react";

// styles
import styles from "./LContainer.module.scss";
import cx from "classnames";

interface ILContainerProps {
    className?: string;
    disableMinHeight?: boolean;
}

// This is depreciated, and should be moved away from. We should use the class "panel-card" instead
const LContainer: React.FC<ILContainerProps> = (props) => {
    const { disableMinHeight, className, children } = props;

    return (
        <div
            className={cx([
                "panel-card",
                "padding-2xl",
                {
                    [className]: !!className,
                    [styles["min-height"]]: !disableMinHeight
                }
            ])}>
            {children}
        </div>
    );
};

export default LContainer;
